import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getUser } from '../services/auth';

/**
 * Central route guard.
 * - Not logged in       -> redirect to /login (remembering where they came from).
 * - Logged in, wrong role -> redirect to their own home area.
 *
 * Usage:
 *   <ProtectedRoute allow={['company']}><CompanyDashboard /></ProtectedRoute>
 *   <ProtectedRoute><Report /></ProtectedRoute>   // any authenticated user
 */
const ProtectedRoute = ({ allow, children }) => {
  const user = getUser();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (allow && !allow.includes(user.type)) {
    return <Navigate to={user.type === 'company' ? '/company/dashboard' : '/jobs'} replace />;
  }

  return children;
};

export default ProtectedRoute;
